<div class='app-map-container'>
  <div class='app-map-wrapper'>
    <iframe
      referrerpolicy="unsafe-url"
      id='design-map'
      type='text/html'
      [src]='contentUrl | safeUrl'
      width='100%'
      height='100%'>
    </iframe>
    <br>
    <div class='d-flex justify-content-end'>
      <button type='button' class='btn btn-secondary' (click)='close.emit()'>Zamknij</button>
    </div>
  </div>
</div>
